import escapeStringRegexp from 'escape-string-regexp';

export const getParameterByName = (parameterName: string) => {
    const url = window.location.href;
    parameterName = escapeStringRegexp(parameterName);
    let regex = new RegExp('[?&]' + parameterName + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const isVillaagarna = () => {
    if (document.location.host.includes('localhost')) {
        return getParameterByName('avtal') == '101';
    } else return document.location.href.includes('webshop-va101');
};

export const isOkq8 = () => {
    if (document.location.host.includes('localhost')) {
        return getParameterByName('avtal') == '202';
    } else return document.location.href.includes('webshop-okq8');
};

export const AGENT_PARAM: string = 'agent';
export const AGREEMENT_PARAM: string = 'avtal';

const ALLOWED_AGREEMENTS: string[] = ['101', '106', '181', '671'];
const ALLOWED_AGENTS: string[] = ['90000', '30435', '30018'];

export const isAgentAndAgreementSpecified = () => {
    return (
        getParameterByName(AGREEMENT_PARAM) != null &&
        ALLOWED_AGREEMENTS.includes(getParameterByName(AGREEMENT_PARAM)) &&
        getParameterByName(AGENT_PARAM) != null &&
        ALLOWED_AGENTS.includes(getParameterByName(AGENT_PARAM))
    );
};

export const isVillaVAInsplanet = () => {
    return (
        getParameterByName(AGENT_PARAM) == '30018' &&
        getParameterByName(AGREEMENT_PARAM) == '101'
    );
};

export const isPROD = () => {
    return window.location.host === 'www.gjensidige.se';
};

const BLOCKED_AGREEMENTS_HOME: string[] = ['106'];
const BLOCKED_AGREEMENTS_VILLA: string[] = ['106', '101'];
const BLOCKED_AGENTS: string[] = ['30018'];

export const isInvalidUrl = () => {
    if (document.location.href.includes('villa-home')) {
        return isAgreementBlockedForAgent(BLOCKED_AGREEMENTS_VILLA);
    } else if (document.location.href.includes('home')) {
        return isAgreementBlockedForAgent(BLOCKED_AGREEMENTS_HOME);
    }

    return false;
};

const isAgreementBlockedForAgent = blockedAgreementList => {
    return (
        getParameterByName(AGENT_PARAM) != null &&
        BLOCKED_AGENTS.includes(getParameterByName(AGENT_PARAM)) &&
        getParameterByName(AGREEMENT_PARAM) != null &&
        blockedAgreementList.includes(getParameterByName(AGREEMENT_PARAM))
    );
};
